import SuccessRegisteredMsg from "../modules/auth/SuccessRegisteredMsg";


export default function SuccessSignUpMessagePage() {
    return (
        <>
            <SuccessRegisteredMsg />
        </>
    );
}
